import PropTypes from 'prop-types';
import { ReactComponent as CalendarIcon } from 'assets/calendar-icon.svg';
import { ReactComponent as StatusIcon } from 'assets/mobile-transaciton-icon.svg';
import { ReactComponent as ProfileIcon } from 'assets/iconButtons/profile.svg';
import { ReactComponent as WalletIcon } from 'assets/wallet.svg';

import './LatestTransactions.scss';

export const TransactionItemLoader = ({ isMobile }) => {
  if (isMobile) {
    return (
      <div className='transaction-item-mobile'>
        <div className='item-mobile-top'>
          <div className='item-mobile-date'>
            <CalendarIcon className='icon' />
            <div className={'loader-placeholder'} />
          </div>
          <div className='item-mobile-status'>
            <StatusIcon className='icon' />
            <div className={'loader-placeholder'} />
          </div>
        </div>
        <div className='item-mobile-from-to'>
          <ProfileIcon className='icon' />
          <div>
            <div className={'loader-placeholder'} />
            <div className={'loader-placeholder'} />
          </div>
        </div>
        <div className='item-mobile-amount'>
          <WalletIcon className='icon' />
          <div className={'loader-placeholder'} />
          <div className={'loader-placeholder'} />
        </div>
      </div>
    );
  }

  return (
    <tr className='transaction-item'>
      <td className='transaction-date'>
        <div className={'loader-placeholder'} />
        <div className={'loader-placeholder'} />
      </td>
      <td className='transaction-status'>
        <div className={'loader-placeholder'} />
      </td>
      <td className='transaction-from-to'>
        <div className={'loader-placeholder'} />
        <div className={'loader-placeholder'} />
      </td>
      <td className='transaction-purpose'>
        <div className={'loader-placeholder'} />
        <div className={'loader-placeholder'} />
      </td>
      <td className={'transaction-amount-commission'}>
        <div className={'loader-placeholder'} />
      </td>
      <td className='transaction-exclamation'>
        <div className={'loader-placeholder'} />
      </td>
    </tr>
  );
};

TransactionItemLoader.propTypes = {
  isMobile: PropTypes.bool
};
